import { EquipmentState } from "@frontend/equipment/types";
import { EquipmentStateBadgeProps } from "./equipment-state-badge.component";


interface ViewProps {
    displayName: React.ReactNode;
    type: string;
}

export const useEquipmentStateBadge = (props: EquipmentStateBadgeProps): ViewProps => {
    return {
        displayName: EquipmentState.getByValue(props.state)?.displayName || 'Unknown',
        type: EquipmentState.getType(props.state)
    }
}